import { useState } from 'react'
import { CompositeComponent } from 'lib'
import { Stack } from '../primitives'
import { SpaceProp } from '../primitives/utils'
import styled from '@emotion/styled'
import { Expanded, TriggerComponent } from './types'
import { DefaultTrigger } from './components/DefaultTrigger'

interface Props extends SpaceProp {
	Trigger?: TriggerComponent
}

export const Expandable: CompositeComponent<Props & Expanded, 'Static' | 'Extra'> = ({
	children,
	expanded: initialExpandedState = false,
	Trigger = DefaultTrigger,
	space
}) => {
	const [expanded, setExpanded] = useState(initialExpandedState)
	return (
		<ExpandingStack space={space} expanded={expanded}>
			{children}
			<Trigger onClick={() => setExpanded(!expanded)} expanded={expanded} />
		</ExpandingStack>
	)
}

Expandable.Static = ({ children }) => <div>{children}</div>
Expandable.Extra = ({ children }) => <Extra>{children}</Extra>

const Extra = styled.div`
	display: none;
`

const ExpandingStack = styled(Stack)<Expanded>`
	${Extra} {
		display: ${({ expanded }) => (expanded ? 'block' : 'none')} !important;
	}
`
